import React from 'react';
import { createRoot } from 'react-dom/client';

import { MeetingsBookingWidget } from '../main-app/components/MeetingsBookingWidget';

document.addEventListener('DOMContentLoaded', () => {
  const meeting = document.getElementById(
    'react-meetings-booking-widget',
  );

  const root = createRoot(meeting);
  root.render(
    <MeetingsBookingWidget
      schoolId={meeting.getAttribute('data-school-key')}
      isMessageAllowed={meeting.getAttribute('data-school-message-allowed') === 'true'}
      schoolName={meeting.getAttribute('data-school-name')}
      schoolTimeZone={meeting.getAttribute('data-school-timezone-name')}
      schoolPhone={meeting.getAttribute('data-school-phone')}
      schoolBookableMeetingKinds={meeting.getAttribute('data-school-bookable-meeting-kinds').split(',')}
    />,
  );
});
